import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const PagChevronRight = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.54116 20.9188C6.19466 20.5722 6 20.1022 6 19.6121C6 19.122 6.19466 18.6519 6.54116 18.3053L12.6276 12.2188L6.54116 6.13235C6.20448 5.78376 6.01818 5.31687 6.02239 4.83225C6.0266 4.34763 6.22098 3.88405 6.56368 3.54136C6.90637 3.19867 7.36995 3.00428 7.85457 3.00007C8.33919 2.99586 8.80608 3.18216 9.15467 3.51884L16.5479 10.9121C16.8944 11.2587 17.0891 11.7287 17.0891 12.2188C17.0891 12.7089 16.8944 13.179 16.5479 13.5256L9.15467 20.9188C8.80806 21.2653 8.33802 21.46 7.84792 21.46C7.35781 21.46 6.88777 21.2653 6.54116 20.9188Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

PagChevronRight.displayName = 'PagChevronRight';
